import { h as e, _ as t, a as o, L as n, P as r, g as a, M as i, b as c } from "./index.browser-dc34ce8e.js";
import s from "react";
import { renderToStaticMarkup as l } from "react-dom/server";
import "camelcase";
let d;
const u = new WeakMap(),
  m = navigator.connection || navigator.mozConnection || navigator.webkitConnection,
  g = ["image", "loading", "isLoading", "isLoaded", "imgClassName", "imgStyle", "objectPosition", "backgroundColor", "objectFit"];
function b(e, t) {
  e.style.opacity = "1", t && (t.style.opacity = "0");
}
function h(e, t, o, n, r, a) {
  const i = e.querySelector("[data-main-image]"),
    c = e.querySelector("[data-placeholder-image]"),
    s = o.has(t);
  function l(e) {
    this.removeEventListener("load", l);
    const t = e.currentTarget,
      o = new Image();
    o.src = t.currentSrc, o.decode ? o.decode().then(() => {
      b(this, c), null == r || r({
        wasCached: s
      });
    }).catch(e => {
      b(this, c), null == a || a(e);
    }) : (b(this, c), null == r || r({
      wasCached: s
    }));
  }
  return i.addEventListener("load", l), null == n || n({
    wasCached: s
  }), Array.from(i.parentElement.children).forEach(e => {
    const t = e.getAttribute("data-src"),
      o = e.getAttribute("data-srcset");
    t && (e.removeAttribute("data-src"), e.setAttribute("src", t)), o && (e.removeAttribute("data-srcset"), e.setAttribute("srcset", o));
  }), o.add(t), i.complete && l.call(i, {
    currentTarget: i
  }), () => {
    i && i.removeEventListener("load", l);
  };
}
function v(t, o, n, r, a, i, c) {
  if (!e()) {
    let e;
    const b = (g = () => {
        e = h(t, o, n, a, i, c);
      }, "IntersectionObserver" in window ? (d || (d = new IntersectionObserver(e => {
        e.forEach(e => {
          var t;
          e.isIntersecting && (null == (t = u.get(e.target)) || t(), u.delete(e.target));
        });
      }, {
        rootMargin: "4g" !== (null == m ? void 0 : m.effectiveType) || null != m && m.saveData ? "2500px" : "1250px"
      })), function (e) {
        return u.set(e, g), d.observe(e), function () {
          d && e && (u.delete(e), d.unobserve(e));
        };
      }) : function () {
        return g(), function () {};
      }),
      v = b(t);
    var s, l;
    return "objectFit" in document.documentElement.style || (t.dataset.objectFit = null != (s = r.objectFit) ? s : "cover", t.dataset.objectPosition = `${null != (l = r.objectPosition) ? l : "50% 50%"}`, async function (e) {
      "objectFitPolyfill" in window || (await import("objectFitPolyfill")), window.objectFitPolyfill(e);
    }(t)), () => {
      e && e(), v();
    };
  }
  var g;
  return h(t, o, n, a, i, c);
}
function f(e) {
  let {
      image: d,
      loading: u = "lazy",
      isLoading: m,
      isLoaded: b,
      imgClassName: h,
      imgStyle: v = {},
      objectPosition: f,
      backgroundColor: p,
      objectFit: y = "cover"
    } = e,
    w = t(e, g);
  const {
    width: j,
    height: C,
    layout: E,
    images: F,
    placeholder: P,
    backgroundColor: L
  } = d;
  return v = o({
    objectFit: y,
    objectPosition: f,
    backgroundColor: p
  }, v), l(s.createElement(n, {
    layout: E,
    width: j,
    height: C
  }, s.createElement(r, o({}, a(P, b, E, j, C, L, y, f))), s.createElement(i, o({}, w, {
    width: j,
    height: C,
    className: h
  }, c(m, b, F, u, v)))));
}
export { f as renderImageToString, v as swapPlaceholderImage };